/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupplementStatus } from './SupplementStatus';
import {
    SupplementStatusFromJSON,
    SupplementStatusFromJSONTyped,
    SupplementStatusToJSON,
    SupplementStatusToJSONTyped,
} from './SupplementStatus';

/**
 * Payload to update an existing supplement
 * @export
 * @interface UpdateSupplementRequest
 */
export interface UpdateSupplementRequest {
    /**
     * 
     * @type {SupplementStatus}
     * @memberof UpdateSupplementRequest
     */
    status?: SupplementStatus;
    /**
     * System-managed workflow processing state
     * @type {string}
     * @memberof UpdateSupplementRequest
     */
    workflowStatus?: UpdateSupplementRequestWorkflowStatusEnum;
    /**
     * US state code (e.g., 'TX', 'AK') for building code justifications
     * @type {string}
     * @memberof UpdateSupplementRequest
     */
    state?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSupplementRequest
     */
    amountRequestedCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSupplementRequest
     */
    amountApprovedCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSupplementRequest
     */
    overallConfidenceScore?: number | null;
}


/**
 * @export
 */
export const UpdateSupplementRequestWorkflowStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type UpdateSupplementRequestWorkflowStatusEnum = typeof UpdateSupplementRequestWorkflowStatusEnum[keyof typeof UpdateSupplementRequestWorkflowStatusEnum];


/**
 * Check if a given object implements the UpdateSupplementRequest interface.
 */
export function instanceOfUpdateSupplementRequest(value: object): value is UpdateSupplementRequest {
    return true;
}

export function UpdateSupplementRequestFromJSON(json: any): UpdateSupplementRequest {
    return UpdateSupplementRequestFromJSONTyped(json, false);
}

export function UpdateSupplementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : SupplementStatusFromJSON(json['status']),
        'workflowStatus': json['workflowStatus'] == null ? undefined : json['workflowStatus'],
        'state': json['state'] == null ? undefined : json['state'],
        'amountRequestedCents': json['amountRequestedCents'] == null ? undefined : json['amountRequestedCents'],
        'amountApprovedCents': json['amountApprovedCents'] == null ? undefined : json['amountApprovedCents'],
        'overallConfidenceScore': json['overallConfidenceScore'] == null ? undefined : json['overallConfidenceScore'],
    };
}

export function UpdateSupplementRequestToJSON(json: any): UpdateSupplementRequest {
    return UpdateSupplementRequestToJSONTyped(json, false);
}

export function UpdateSupplementRequestToJSONTyped(value?: UpdateSupplementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': SupplementStatusToJSON(value['status']),
        'workflowStatus': value['workflowStatus'],
        'state': value['state'],
        'amountRequestedCents': value['amountRequestedCents'],
        'amountApprovedCents': value['amountApprovedCents'],
        'overallConfidenceScore': value['overallConfidenceScore'],
    };
}

